import React from 'react'
import { blue } from "@material-ui/core/colors";
import RegularButton from "components/CustomButtons/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Edit from "@material-ui/icons/Edit";

const configTable = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) =>
      row.name.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Alias",
    accessor: "alias",
    filterable: true,
    filterMethod: (filter, row) =>
      row.alias.toLowerCase().includes(filter.value.toLowerCase()),
  },

  {
    Header: "Teléfono de servicio",
    accessor: "servicePhone",
    filterable: true,
    filterMethod: (filter, row) =>
      row.servicePhone.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Teléfono de fugas",
    accessor: "leakPhone",
    filterable: true,
    filterMethod: (filter, row) =>
      row.leakPhone.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Licencia",
    accessor: "creLicense",
    filterable: true,
    filterMethod: (filter, row) =>
      row.creLicense.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Dirección",
    accessor: "address",
    filterable: true,
    filterMethod: (filter, row) =>
      row.address.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Planta",
    accessor: "stationName",
  },
  {
    Header: "Acciones",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({original}) => {
      const hist = useHistory()
      const handleChangePage = (page) => {
        const newDirection = page ? page : "/admin/nuevo_marca";
        hist.push(newDirection);
      };
      return (
      <div className="actions-right">
          <RegularButton
            justIcon
            round
            color="transparent"
            tooltip="Editar"
            onClick={() =>
              handleChangePage(`/admin/editar_marca_planta/editar/${original?.id}`)
            }

          >
            <Edit style={{color: blue[800]}}/>
          </RegularButton>
      </div>
    )},
  }
];

export { configTable };
